import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const qrCodeGeneratorTool: Tool = {
  id: "qr-code-generator",
  name: () => m.qr_tool_name(),
  description: () => m.qr_tool_description(),
  icon: "🔳",
  basePath: "/qr-code-generator",
  status: "stable",
  tags: ["everyday", "qr", "generator", "qr-code-generator"],
};
